import * as schema from '@strength/db-schema';
import { z } from 'zod';
import { createAppInsertSchema, schemaToModelChange, } from '../../../utils/schema';
import { zWorkoutLayer } from '../../../workout/layer';
export var AthleteDraftWorkoutDomain;
(function (AthleteDraftWorkoutDomain) {
    AthleteDraftWorkoutDomain.Module = 'AthleteDraftWorkout';
    AthleteDraftWorkoutDomain.zEdit = schemaToModelChange('AthleteDraftWorkoutLayer', createAppInsertSchema(schema.AthleteDraftWorkoutLayer)
        .omit({
        unpublishedChangeCount: true,
        blockId: true,
        profileId: true,
        workoutId: true,
    })
        .extend({
        // `createInsertSchema` doesn't handle the layer type very well
        layer: zWorkoutLayer,
    }));
    const zIdentity = z.object({
        blockId: z.uuid(),
        profileId: z.uuid(),
        workoutId: z.uuid(),
    });
    AthleteDraftWorkoutDomain.zCommand = z.object({
        module: z.literal(AthleteDraftWorkoutDomain.Module),
        identity: zIdentity,
        edits: AthleteDraftWorkoutDomain.zEdit.array(),
        // Whether or not to update the unpublishedChangeCount
        // undefined = use normal behavior
        updateChangeCount: z.boolean().optional(),
    });
})(AthleteDraftWorkoutDomain || (AthleteDraftWorkoutDomain = {}));
//# sourceMappingURL=domain.js.map